import { type FunctionComponent } from "react";

import { ClientSideSuspense } from "shared/components/common/client-side-suspense";

import { AppFooter } from "scmp-app/components/app-footer";
import { NewsAgendaContextProvider } from "scmp-app/components/plus/news-agenda/contexts";
import { PlusPaywallSuspense } from "scmp-app/components/plus/plus-paywall-suspense";

import { PlusNewsAgendaLeft } from "./left";
import { PlusNewsAgendaPlaceholder } from "./placeholder";
import { PlusNewsAgendaRightPlaceholder } from "./placeholder/right";
import { PlusNewsAgendaRight } from "./right";
import { Container, Left, PlaceholderContainer, Right, Wrapper } from "./styles";

type Props = {
  className?: string;
};

export const PlusNewsAgenda: FunctionComponent<Props> = ({ className }) => (
  <NewsAgendaContextProvider>
    <Container className={className}>
      <PlusPaywallSuspense
        fallback={
          <PlaceholderContainer>
            <PlusNewsAgendaPlaceholder />
          </PlaceholderContainer>
        }
      >
        <Wrapper>
          <Left>
            <PlusNewsAgendaLeft />
          </Left>
          <Right>
            <ClientSideSuspense fallback={<PlusNewsAgendaRightPlaceholder />}>
              <PlusNewsAgendaRight />
            </ClientSideSuspense>
          </Right>
        </Wrapper>
        <AppFooter variant="plus-without-app-link-row-and-fixed" />
      </PlusPaywallSuspense>
    </Container>
  </NewsAgendaContextProvider>
);

PlusNewsAgenda.displayName = "PlusNewsAgenda";
